import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  deliveryWithinFromModel,
  validateDeliveryWithinCondition,
  type DeliveryWithinState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const DELIVERY_WITHIN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DeliveryWithinState>>,
): ConditionType<DeliveryWithinState, Condition.ShippingWithin> => ({
  name: "Time since delivery",
  description(state) {
    return `Within ${state} days of delivery`;
  },
  Details(props: ConditionTypeDetailsProps<DeliveryWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return deliveryWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.DELIVERY_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return validateDeliveryWithinCondition(state).valid;
  },
});

export { type DeliveryWithinState } from "@redotech/redo-model/return-flow/condition-validate";
